
export const constants={
    baseUrl:"https://lightride.site/"
  }